module.exports = __webpack_public_path__ + "img/ibank.05182381.svg";